<script>
	import { getContext } from "svelte";
	import { fade } from "svelte/transition";

	import { animationParameters } from "../constants";

	const { padding, custom } = getContext("LayerCake");

	export let label;
</script>

<div
	class="timeline-label"
	style:left={25 - $custom.marginLeft - $padding.left + "px"}
	style:width={$custom.marginLeft + "px"}
>
	<div class="text">
		<div class="label">
			{label}
		</div>
	</div>
</div>

<style lang="scss">
	@import "../main.scss";

	.timeline-label {
		position: absolute;
		top: calc(100% + #{$offset-timeline + 14px});
		display: flex;
		justify-content: flex-end;
		flex-direction: row;
		align-items: center;
		column-gap: 4px;
		transform: translate(0, -50%);
		padding-right: 8px;
		font-weight: $medium;
		color: $grey;
	}

	// <= small tablets
	@media (max-width: $breakpoint-tablet-s) {
		.timeline-label {
			display: none;
		}
	}

	.label-main {
		font-weight: $medium;
		margin-bottom: 5px;
	}

	.arrow {
		width: 0;
		height: 0;
		border-top: 6px solid transparent;
		border-bottom: 6px solid transparent;

		border-left: 6px solid $black;
	}

	.arrow img {
		width: 20px;
		transform: scale(1, 1) rotate(225deg);
	}
</style>
